module.exports = __webpack_public_path__ + "static/interior_right-f6cee2f5be5ae831c0809d6bf7cab554.webp";